import React from 'react';

import { DialogDatagrid } from '../../../common/dialogs/DialogDatagrid';
import { GameField } from '../../games/GameField';

export const GamePurgeGrid = ({ ...props }) =>
  <DialogDatagrid size="medium" {...props}>
    <GameField source="gameId" label="resources.gamePurges.labels.games_purged" link="scoresheet" includeDate="inline" includeSurface="full" sortable={false} />
  </DialogDatagrid>
